
import { PasswordInput, NumberKeyboard, Toast } from "vant";
Vue.use(PasswordInput);
Vue.use(NumberKeyboard);
import { Component, Vue, Watch } from "vue-property-decorator";
import {
  getPhoneCode,
  checkPhoneCode,
  judgePhoneLogin,
  bindPhone,
  phoneLogin,
} from "@/req/login";
import NavBar from "./header.vue";
@Component({
  components: {
    NavBar,
  },
})
export default class Logout extends Vue {
  // 表单效验规则
  public loginFormRules = {
    code: [{ required: true }, { pattern: /^[\d]{4,6}$/ }],
  };
  public passwordShow = false;
  public btnCode = false;
  public showKeyboard = true;
  public smsCountTime = true;
  public Loginflag = false;
  public countdown = 60;
  public timer: any = "";
  public phone: any = "";
  public flag: any = "";
  public phones: any = "";
  public formLogin = {
    username: "",
    password: "",
    phone: "",
    code: "",
  };

  public mounted() {
    this.smsCountDown();
    if (this.bindPhoneData()) return;
    this.getPhone();
  }
  @Watch("formLogin.code")
  public codeWatch() {
    if (this.formLogin.code.length === 4) {
      this.onSubmit();
    }
  }
  public bindPhoneData() {
    let flag = false;
    const data: any = this.$route.params.formLogin
      ? this.$route.params.formLogin
      : this.formLogin;
    if (data.username) {
      flag = true;
      this.formLogin = data;
      this.phones = this.formLogin.phone.replace(
        /(\w{4})(\w{4})(.*)/,
        "$1****$3"
      );
    }
    this.Loginflag = flag;
    return flag;
  }
  public getPhone() {
    if (this.$route.params.phone) {
      sessionStorage.setItem("phone", this.$route.params.phone);
    }
    if (this.$route.params.flag) {
      sessionStorage.setItem("flag", this.$route.params.flag);
    }
    this.phone = sessionStorage.getItem("phone");
    this.flag = sessionStorage.getItem("flag");
    this.phones = this.phone.replace(/(\w{4})(\w{4})(.*)/, "$1****$3");
  }

  // 登录/修改密码
  public async onSubmit() {
    if (this.formLogin.code.length < 4) return;
    if (this.Loginflag) return this.bindPhone();
    const obj = {
      phone: this.phone,
      promote_code: "",
      code: this.formLogin.code,
    };
    let res;
    if (this.flag === "login") {
      res = await phoneLogin(obj);
    } else {
      res = await checkPhoneCode(obj);
    }
    if (res.code === 200) {
      if (this.flag === "login") {
        this.$fn.cookies.setToken(res.data.token);
        this.$router.push({ name: "my" });
      } else {
        this.$router.push({
          name: "setPassWord",
          params: { phone: this.phone, code: this.formLogin.code },
        });
      }
    } else {
      Toast(res.msg);
    }
  }
  public async bindPhone() {
    const obj = {
      username: this.formLogin.username,
      password: this.formLogin.password,
      phone: this.formLogin.phone,
      code: this.formLogin.code,
    };
    const res = await bindPhone(obj);
    if (res.code == 200) {
      this.$fn.cookies.setToken(res.data.token);
      this.$router.push({ name: "my" });
    } else {
      Toast(res.msg);
    }
  }
  // 再次获取验证码
  public async onCode() {
    this.btnCode = false;
    this.smsCountDown();
    const obj = {
      phone: this.phone,
    };
    const res = await getPhoneCode(obj);
    if (res.code !== 200) {
      Toast(res.msg);
    }
  }
  // 验证码倒计时
  public smsCountDown() {
    const self = this;
    this.timer = setInterval(() => {
      self.countdown--;
      if (self.countdown === 0) {
        clearInterval(self.timer);
        self.countdown = 60;
        self.smsCountTime = true;
        self.btnCode = true;
      }
    }, 1000);
  }
  // public onInput() {
  //   if (this.formLogin.code.length === 4) {
  //     this.onSubmit();
  //   }
  // }
}
